import {common} from '@priority-software/priority-proto-api/lib';
import {action} from 'mobx';
import {homepageStore} from '../store/HomepageStore';
import {
    setServerStoreData,
    getServerStoreData
} from '../../../services/proto/ServerStorage/service';
import {getLang} from '../../../Localization';

const separator = '///';

export const getCollapsedGroupsKey = () => {
    const collapsedGroupsKey = 'homepage:collapsedGroups';

    return `${collapsedGroupsKey}-${getLang()}`;
};

export const getCollapsedGroupsData = async () => {
    const key = getCollapsedGroupsKey();
    const res = await getServerStoreData([key], false, true);
    const data = res?.[key]?.Str || '';

    return data.split(separator).filter(Boolean) || [];
};

export const updateCollapsedGroupState = async (groupName: string, isCollapsed: boolean) => {
    const storedData: string[] = homepageStore.collapsedGroups;
    const data: string[] = isCollapsed
        ? [...new Set([...storedData, groupName])]
        : homepageStore.collapsedGroups.filter(group => group !== groupName);

    return setCollapsedGroupsData(data);
};

export const toggleGroup = action((groupName: string, isHidden: boolean) => {
    const group = homepageStore.groups.get(groupName);
    if (group) {
        group.isHidden = isHidden;
        // Create a new map to trigger mobx update (TODO: discuss this with Alex)
        homepageStore.groups = new Map(homepageStore.groups);
    }
});

export const setCollapsedGroupsData = async (data: Array<string>) => {
    await setServerStoreData(
        {
            [getCollapsedGroupsKey()]: new common.Constant({Str: data.join(separator)})
        },
        true,
        false
    );

    homepageStore.setCollapsedGroups(data);
};
